import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import compose from 'recompose/compose';
import withHanders from 'recompose/withHandlers';
import cloneDeep from 'lodash/cloneDeep';
import { getInitialValues, getShopBookNoPay } from './selectors';
import BarberSettingsTable from './BarberSettingsTable';
import { updateBarber, getBarbers } from '../../barbers/actions';
import { updateShop } from '../../shops/actions';
import { prepareForSaving } from '../../../common/helpers/modelSettings';
import withMinInterval from '../../../common/hoc/withMinInterval';
import withMinuteOptions from '../../../common/hoc/withMinuteOptions';

const FORM = 'barberSettings';

const form = reduxForm({
  form: FORM,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
});

const mapStateToProps = (state) => ({
  initialValues: getInitialValues(state),
  shopBookNoPay: getShopBookNoPay(state),
});

const mapDispatchToProps = {
  updateBarber,
  updateShop,
  getBarbers,
};

const BarberSettingsTableContainer = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withMinInterval,
  withMinuteOptions,
  withHanders({
    onSubmit: (props) => (formData) => {
      const data = cloneDeep(formData);
      const actions = data.barbers.map((barber) => {
        return props.updateBarber(barber.id, prepareForSaving(barber, props.minInterval));
      });
      const shop = data.shops[0];
      delete shop.name;
      const updateShopAction = props.updateShop(shop.id, prepareForSaving(shop, props.minInterval));
      actions.push(updateShopAction);
      return Promise.all(actions);
    },
    override: (props) => (formData) => {
      const data = cloneDeep(formData);
      const shop = data.shops[0];
      shop.overrideBarberSettings = true;
      delete shop.name;
      return props.updateShop(shop.id, prepareForSaving(shop, props.minInterval)).then(() => props.getBarbers(shop.id));
    },
  }),
  form
)(BarberSettingsTable);

export default BarberSettingsTableContainer;
